'use client';

import { createContext, useContext, type Provider } from 'react';

import type { AnalyticsPlatformContext } from '../hooks/analytics/useAnalyticsEvent';

const AnalyticsPlatformContextInternal = createContext<AnalyticsPlatformContext | null>(null);
AnalyticsPlatformContextInternal.displayName = 'AnalyticsPlatformContext';

export const AnalyticsPlatformProvider = AnalyticsPlatformContextInternal.Provider as Provider<AnalyticsPlatformContext>;

/**
 * Returns the platform context from the nearest AnalyticsPlatformProvider, or null if none exists.
 * This allows useAnalyticsEvent to work both with a direct platformContext arg (webapp/mobile hooks)
 * and via Provider (shared-components).
 */
export function useAnalyticsPlatformContext(): AnalyticsPlatformContext | null {
  return useContext(AnalyticsPlatformContextInternal);
}
